import { Component, OnInit, Inject, Output, EventEmitter } from '@angular/core';
import { LocalStorageService } from 'ngx-webstorage';
import { UsersModel } from 'src/app/models/UsersModel';
import { UsersService } from 'src/app/services/UsersService';
import { UsersComponent } from '../users/users.component';
import { CompanyService } from 'src/app/services/CompanyService';
import { CompanyModel } from 'src/app/models/CompanyModel';
import { FormsModule } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import swal from 'sweetalert2';
import { UserChangePopComponent } from '../user-change-pop/user-change-pop.component';
import { Route, Router } from '@angular/router';
import { HomeComponent } from '../home/home.component';



@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.css'],
})
export class LoginComponent implements OnInit {
  userID ='';
  userName = '';
  enabled =  '';
  empID = '';
  groupCode ='';
  Password ='';
  passwordEntry ='';
  userID1 = '';
  modifiedDate = '2021-01-01';
  compCode ='1' ;

  compCode1 ='1'
  compName ='' ;
  compAddress ='' ;
  compPhone ='' ;
  compContact ='' ;
  compUser1 ='' ;
  compUser2 ='' ;
  compUserNumb ='' ;
  compUserDate ='' ;
  compPath ='' ;
  userID2 = '';
  styleFor = 'black';
  styleFor1 = 'black';
  styleVis  = true;
  stylehidden  = true;
   lblError = 'ERROR';
   sellersPermitString = '';
   myimage;


  Check_User = 'False';
  Check_Password = 'False';
  Check_Company = 'False';
  Check_message1 = '';
  Check_message2 = '';
  Check_message3 = '';
  Get_Login : boolean = false;
   companyList: CompanyModel[] = [];
   @Output() submitClicked = new EventEmitter<any>();

  wk_Pic_Not = false;
  wk_Pic_Not1 = true;


  constructor(public storage: LocalStorageService,
              public usersService: UsersService,
              public users: UsersModel,
              private dialogref: MatDialog,
              public companyService: CompanyService,
              public company: CompanyModel,
            private router: Router) {}

  ngOnInit(): void {
      this.retrivePicDefult();
      this.retriveCompanyLookupTop();
      this.wk_Pic_Not = false;
      this.wk_Pic_Not1 = true;
      this.retriveUsers();
    if (this.compCode !== '10'){this.compCode1 === '1'}
    if (this.compCode !== '10'){this.compCode === '1'}
  }



  // LoginUser() {
  //   debugger;
  //     //// =========== Check User ========================
  //     this.Check_message1 = '';
  //     this.Check_User = 'False';
  //     if (this.userName == null || this.userName == "" ) {
  //       this.Check_User = 'False'
  //       this.Check_message1 = 'Invalid User ID  .. '

  //     } else {
  //        this.Check_User = 'true';
  //     }
  //     //// =========== Check PassWord ===================
  //     this.Check_Password = 'False';
  //     this.Check_message2 = '';
  //     if (this.Password != this.passwordEntry || this.passwordEntry == '') {
  //         this.Check_Password = 'False'
  //         this.Check_message2 = 'Invalid Password  .. '
  //     }
  //     else
  //     {
  //       this.Check_Password = 'true';
  //     }
  //     //// =========== Check Company ===================

  //     this.Check_Company = 'False';
  //     this.Check_message3 = '';
  //     if (this.compCode == '') {

  //         this.Check_Company = 'False'
  //         this.Check_message3 = 'Invalid Company  .. '

  //     }
  //     else
  //     {
  //       this.Check_Company = 'true';
  //     }
  //       if(this.Check_Company == 'true' && this.Check_User == 'true' && this.Check_Password == 'true')
  //     {

  //       this.Get_Login = true;
  //     }

  //     else
  //     {
  //       this.Get_Login = false;
  //       this.messageEnglish();
  //     }
  //     if (this.compCode1 == '' || this.compCode1 ==null)
  //     {
  //       this.Get_Login = false;
  //     }

  //     this.storage.store('stgusername', this.userName);
  //     this.storage.store('stgcompCode', '1');
  //     this.storage.store('stgLocation', this.compCode1);
  //     this.storage.store('stgUserId', this.userID);
  //     this.storage.store('stgGroup', this.groupCode);
  //     this.storage.store('stgEmpId', this.empID);


  // }
  retriveCompany(){
    this.Check_Company == 'true'
  }
  retriveUsers() {
    this.usersService.getusers(this.userID, '1').subscribe(
      (data: UsersModel) => {

        this.userName = data.userName;
        this.enabled = data.enabled;
        this.empID = data.empID;
        this.groupCode = data.groupCode;
        // this.Password = data.password;
        this.userID1 = data.userID1;
        this.modifiedDate = data.modifiedDate;
        this.compCode = data.compCode;

        if (this.userName == null)

          this.userName ="",
          this.retrivePicDefult();

          else
          this.styleFor = "black";
          this.retrivePic();
      }
    );

  }
  retrivePic(){
    this.usersService.getusersPic(this.userID, '1').subscribe((data: UsersModel) => {
      this.myimage = data.iTPicture;
      this.sellersPermitString =  data.iTPicture;
      this.myimage =this.sellersPermitString;
      this.storage.store('stgmyImage', this.myimage);
      var kk = this.sellersPermitString;

      if( this.myimage == null) {this.retrivePicDefult()}
      if(this.myimage =='' || this.myimage == null)
        {
          this.wk_Pic_Not = false;
          this.wk_Pic_Not1 = true;
        }
        else
        {
          this.wk_Pic_Not = true;
          this.wk_Pic_Not1 = false;
        }

    }

    );

   }

   retrivePicDefult(){
        this.usersService.getDefultPic('evan', '1').subscribe((data: UsersModel) => {
        this.myimage = data.iTPicture;
        this.sellersPermitString =  data.iTPicture;
        this.myimage =this.sellersPermitString;
        this.storage.store('stgmyImage', this.myimage);


        var kk = this.sellersPermitString;
    }

    );
   }
  ChkPassword(){

    this.Check_Password = 'False';
    this.Check_message2 = '';
    if (this.Password != this.passwordEntry) {
        this.Check_Password = 'False'
        {this.Check_message2 = 'Invalid Password  .. '}
     }
    else
    {
      this.Check_Password = 'true';
    }


  }




CheckUser() {

  this.usersService.CheckUser(this.userID, this.passwordEntry).subscribe(
    (data: UsersModel) => {
      if (!data) {
        this.Get_Login = false;
        this.messageEnglish();
        return;
      }
       this.userName = data.userName;

        this.enabled = data.enabled;
        this.empID = data.empID;
        this.groupCode = data.groupCode;
        // this.Password = data.password;
        this.userID1 = data.userID1;
        this.modifiedDate = data.modifiedDate;
        this.compCode = data.compCode;

        if (this.userName == null){

          this.userName ="",
          this.retrivePicDefult();
        }
          else
          {
          this.styleFor = "black";
          this.retrivePic();
      }

      // this.myimage0 = data.itpicture;

      // تخزين JWT
      localStorage.setItem("token", data.token);
      localStorage.setItem("user", JSON.stringify(data.userName));
      // تخزين البيانات
      this.storage.store('stgusername', this.userName);
      this.storage.store('stgLocation', this.compCode1);
      this.storage.store('stgcompCode', this.compCode1);
      this.storage.store('stgUserId', this.userID);
      this.storage.store('stgGroup', this.groupCode);
      this.storage.store('stgEmpid', this.empID);
      // this.storage.store('stgmyImage', this.myimage0);
      console.log (this.storage.retrieve('stgcompCode'))
      // التحقق من تسجيل الدخول
    if (data && data.token && this.compCode != '') {
          localStorage.setItem("token", data.token);
        this.router.navigate(["/Home"]);
        //this.dialogref.close(true);
        this.Get_Login = true;
} else {

  this.Get_Login = false;
  this.messageEnglish();

}

    },
    error => {
      console.log(error);
      this.messageEnglish();
    }
  );
}



  retriveCompanyLookupTop() {
    this.companyService
      .getLocationLookupTop(this.compCode)
      .subscribe((data: CompanyModel[]) => {
        for (let i = 0; i < data.length; i++) {
          this.companyList[i] = data[i];
        }

      });
  }

  messageEnglish(){
         this.Check_message1 = 'Invalid User ID  .. ';
         this.Check_message2 = ' Or Invalid Password  .. ';
    swal({
      title: this.Check_message1 + ' ' + this.Check_message2 + ' ' + this.Check_message3,
      type: 'warning',
      showConfirmButton: false,


      timer: 3000,

    });
  }

  ChkRefresh(){
    window.location.reload();
  }

  ChangePassword(){
    this.Check_User = 'False';
    if (this.userName == null || this.userName == "") {
      this.Check_User = 'False'
      this.Check_message1 = 'Invalid User Code  .. Please try again'
    } else {
      this.Check_User = 'true';
    }
    if (this.Check_User == 'true'){
    const dialogRef = this.dialogref.open(UserChangePopComponent,
      {

        data: {
          dataKey: this.users,
          userid :this.userID
        },
        width: '35vw',

      });

    dialogRef.afterClosed().subscribe(result => {
    });

    const dialogSubmitSubscription =
      dialogRef.componentInstance.submitClicked.subscribe(result => {
        dialogSubmitSubscription.unsubscribe();
      });
    }
  }


}


